import { StcCustomContentsModel } from '../models/stc_custom_contents_model';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { STCSchedulingConfigModel } from '../models/stc_scheduling_config_model';
import { AppointmentSchedulingServant } from './appointment_scheduling_servant';
import { GetScheduleAppointmentLabelCommand } from '../commands/get_schedule_appointment_label_command';

export class CustomContentsServant {
  constructor(
    private ngStcCustomContentsModel: StcCustomContentsModel,
    private loadStcCustomContentsCommand: ICommand,
    private ngStcSchedulingConfigModel: STCSchedulingConfigModel,
    private ngAppointmentSchedulingServant: AppointmentSchedulingServant,
    private appConfigModel: any,
    private getScheduleAppointmentLabelCommand: GetScheduleAppointmentLabelCommand
  ) {}

  getButtonLabel(defaultValue: string) {
    return this.getScheduleAppointmentLabelCommand(defaultValue);
  }

  getStcCustomContents() {
    return new Promise((resolve, reject) => {
      if (_4.isUndefined(this.ngStcCustomContentsModel.read().student_scheduling)) {
        this.loadStcCustomContentsCommand()
          .then((data: any) => resolve(data))
          .catch((err: any) => reject(err));
      } else {
        let data = this.ngStcCustomContentsModel.read();
        resolve(data);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/servants/custom_contents_servant.ts